import RetailerService from "./RetailerService";

export { default } from './RetailerService';
export const retailerService = new RetailerService();
